<template>
  <component :is="login" :type="type" @showregist="showIt" />
</template>

<script>
export default {
  name: 'login',
  components: {
    commonLogin: () => import(`@/components/different/common/login/login`),
    venicemanLogin: () => import(`@/components/different/veniceman/login/login`),
    betlLogin: () => import(`@/components/different/betl/login/login`),
    b027siteLogin: () => import(`@/components/different/b027site/login/login`),
    b027sportLogin: () => import(`@/components/different/b027sport/login/login`)
  },
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      differentSite: null
    }
  },
  computed: {
    login() {
      switch (process.env.siteName) {
        case 'veniceman':
          this.differentSite = true
          break
        case 'betl':
          this.differentSite = true
          break
        case 'b027site':
          this.differentSite = true
          break
        case 'b027sport':
          this.differentSite = true
          break
        default:
          this.differentSite = false
          break
      }
      return (this.differentSite ? `${process.env.siteName}Login` : 'commonLogin')
    }
  },
  created () {

  },
  methods: {
    showIt () {
      this.$emit('showregist')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
</style>



// WEBPACK FOOTER //
// login.vue?e9295180